/* Theme-only preview enhancements. No review is sent or stored by the demo form. */
(() => {
  'use strict';
  const quantity = value => ['1', '2', '3'].includes(String(value)) ? Number(value) : null;
  const total = (cents, count) => Number.isSafeInteger(cents) && cents >= 0 && quantity(count) ? cents * quantity(count) : null;
  const money = (cents, currency) => new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(cents / 100);
  if (typeof module !== 'undefined' && module.exports) { module.exports = { quantity, total, money }; return; }
  const focusReturn = new WeakMap();
  const show = dialog => {
    if (!dialog || dialog.open) return;
    focusReturn.set(dialog, document.activeElement);
    if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
  };
  const close = dialog => {
    if (!dialog) return;
    if (typeof dialog.close === 'function') dialog.close(); else dialog.removeAttribute('open');
    focusReturn.get(dialog)?.focus();
  };
  const element = (tag, cls, text) => {
    const node = document.createElement(tag); if (cls) node.className = cls;
    if (text != null) node.textContent = text;
    return node;
  };
  function moveModules() {
    const home = document.querySelector('[data-vq-family-pathways]');
    const anchor = document.querySelector('.vq-factory-strip') || document.querySelector('.vq-factory-hero');
    if (home && anchor && !home.dataset.vqMoved) { anchor.after(home); home.dataset.vqMoved = 'true'; }
    const native = document.querySelector('vessariq-native-product');
    const main = native?.closest('.shopify-section');
    const intelligence = document.querySelector('[data-vq-product-intelligence]')?.closest('.shopify-section');
    const reviews = document.querySelector('[data-vq-reviews]')?.closest('.shopify-section');
    if (main && intelligence && !intelligence.dataset.vqMoved) {
      main.after(intelligence); if (reviews) intelligence.after(reviews); intelligence.dataset.vqMoved = 'true';
    }
  }
  function initProduct(panel) {
    if (panel.dataset.vqReady || !panel.isConnected) return;
    const native = document.querySelector('vessariq-native-product');
    if (!native) return;
    let variants;
    try { variants = JSON.parse(panel.querySelector('[data-vq-intelligence-data]').textContent).variants; } catch { return; }
    const original = native.querySelector('.vnp-form');
    const compact = panel.querySelector('[data-vq-pdp-compact]');
    const copy = native.querySelector('.vnp-copy');
    if (!original || !compact || !copy) return;
    panel.dataset.vqReady = 'true';
    native.__vqReviewAbort?.abort();
    const abort = new AbortController();
    native.__vqReviewAbort = abort;
    const listen = (node, event, handler) => node.addEventListener(event, handler, { signal: abort.signal });
    native.querySelectorAll('[data-vq-pdp-compact],.vq-pdp-jumps').forEach(node => { if (node !== compact) node.remove(); });
    original.hidden = false;
    native.querySelector('.vnp-layout').after(compact);
    const hairPicker = compact.querySelector('[data-vq-hair-versions]');
    const nativeOptions = original.querySelector('[data-vnp-options]');
    if (hairPicker && nativeOptions && hairPicker.dataset.mode === 'preview' && !hairPicker.dataset.vqHairPickerMoved) {
      nativeOptions.before(hairPicker);
      hairPicker.dataset.vqHairPickerMoved = 'true';
    }
    native.querySelectorAll('.vnp-details').forEach(node => { node.hidden = true; });
    const jumps = compact.querySelector('.vq-pdp-jumps');
    jumps?.remove();
    const sync = variant => {
      if (!variant) return;
      compact.querySelectorAll('[data-vq-spec-option]').forEach(node => {
        const value = variant.options[Number(node.dataset.vqSpecOption)] || 'Not selected';
        node.textContent = value.includes('%') ? value.replace(/^(SD|DD)/i, '') : value;
        if (value.includes('%')) node.previousElementSibling.textContent = 'Density';
      });
    };
    const source = compact.querySelector('[data-vq-source-specs]');
    const table = compact.querySelector('[data-vq-spec-table]');
    const labels = new Set([...table.querySelectorAll('dt')].map(node => node.textContent.trim().toLowerCase()));
    source?.querySelectorAll('dl').forEach(dl => {
      [...dl.querySelectorAll('dt')].forEach(dt => {
        const dd = dt.nextElementSibling;
        const label = dt.textContent.trim();
        if (dd?.tagName === 'DD' && label && !labels.has(label.toLowerCase())) {
          const row = element('div'); row.append(element('dt', '', label), element('dd', '', dd.textContent.trim())); table.append(row); labels.add(label.toLowerCase());
        }
      });
      dl.hidden = true;
    });
    const title = native.querySelector('h1')?.textContent || '';
    if (!labels.has('lace area')) {
      const lace = title.match(/(13|5|4)\s*[×x]\s*(6|5|4)/i);
      if (lace) { const row = element('div'); row.append(element('dt', '', panel.dataset.productFormat === 'bundles' ? 'Included closure lace area' : 'Lace area (listing)'), element('dd', '', `${lace[1]} × ${lace[2]} inches`)); table.append(row); }
    }
    if (/\bHD\b/i.test(title) && !labels.has('lace type')) {
      const row = element('div'); row.append(element('dt', '', 'Lace type (listing)'), element('dd', '', 'HD lace')); table.append(row);
    }
    const readNativeVariant = () => variants.find(v => v.id === native.querySelector('[data-vnp-id]')?.value);
    listen(original, 'change', () => queueMicrotask(() => sync(readNativeVariant())));
    listen(window, 'popstate', () => queueMicrotask(() => sync(readNativeVariant())));
    sync(readNativeVariant() || variants.find(v => v.available) || variants[0]);
    const specDialog = panel.querySelector('[data-vq-spec-dialog]');
    const specButton = compact.querySelector('[data-vq-open-specs]');
    specButton.hidden = false;
    specButton.addEventListener('click', () => {
      const body = specDialog.querySelector('[data-vq-spec-dialog-body]');
      body.replaceChildren(table.cloneNode(true));
      if (source) body.append(source.cloneNode(true));
      show(specDialog);
    });
    const builder = compact.querySelector('[data-vq-bundle-builder]');
    if (!builder || native.dataset.reviewRequired === 'true') return;
    const form = builder.querySelector('form');
    const select = form.querySelector('[name=id]');
    const button = form.querySelector('button[type=submit]');
    const status = form.querySelector('[data-vq-bundle-status]');
    const currency = panel.dataset.currency || 'USD';
    let busy = false;
    function selection() { return { variant: variants.find(v => v.id === select.value), count: quantity(new FormData(form).get('quantity')) }; }
    function render(changeUrl = true) {
      const { variant, count } = selection();
      button.disabled = busy || !variant?.available || !count;
      if (!variant || !count) { status.textContent = 'Choose an available specification and quantity.'; return; }
      form.querySelectorAll('[data-vq-pack-total]').forEach(node => { node.textContent = money(total(variant.price, node.dataset.vqPackTotal), currency); });
      form.querySelector('[data-vq-selection-total]').textContent = money(total(variant.price, count), currency);
      sync(variant);
      if (native.fields && native.select && typeof native.updateVariant === 'function') {
        native.fields.forEach((field, i) => field.querySelectorAll('input').forEach(input => { input.checked = input.value === variant.options[i]; }));
        native.select.value = variant.id; native.updateVariant(false);
      }
      if (changeUrl) { const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url); }
    }
    listen(form, 'change', () => render());
    listen(window, 'popstate', () => {
      const id = new URL(location.href).searchParams.get('variant');
      if (variants.some(v => v.id === id)) { select.value = id; render(false); }
    });
    listen(form, 'submit', event => {
      event.preventDefault();
      if (busy || !form.reportValidity()) return;
      const { variant, count } = selection();
      if (!variant?.available || !count) return;
      const earlierWrites = window.VessariqCartNavigation?.wait();
      const request = (async () => {
        busy = true; const controls = [...form.querySelectorAll('input,select,button')];
        const disabledBefore = controls.map(control => control.disabled);
        controls.forEach(control => { control.disabled = true; });
        button.setAttribute('aria-busy', 'true'); status.textContent = 'Adding your selection…';
        let added = false;
        try {
          await earlierWrites;
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart/add.js`, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: variant.id, quantity: count }] }) });
          let result; try { result = await response.json(); } catch { throw new Error('We could not confirm the add. Check your cart before trying again.'); }
          if (!response.ok) throw new Error(result.description || result.message || 'This selection could not be added.');
          added = true; status.textContent = `Added ${count} ${count === 1 ? 'bundle' : 'bundles'} to your cart.`;
          try {
            const cartResponse = await fetch(`${root}cart.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
            if (cartResponse.ok) { const cart = await cartResponse.json(); document.querySelectorAll('[data-vq-cart-count]').forEach(node => { node.textContent = String(cart.item_count); }); document.dispatchEvent(new CustomEvent('vq:cart-updated', { detail: { cart } })); }
          } catch { /* A badge refresh is not an add failure. */ }
        } catch (error) {
          if (!added) status.textContent = error instanceof TypeError ? 'We could not confirm the add. Check your cart before trying again.' : error.message;
        } finally {
          busy = false; controls.forEach((control, i) => { control.disabled = disabledBefore[i]; }); button.removeAttribute('aria-busy'); render(false);
        }
      })();
      window.VessariqCartNavigation?.track(request);
    });
    builder.hidden = false;
    original.hidden = true;
    render(false);
  }
  function initReviews(section) {
    if (section.dataset.vqReady) return;
    section.dataset.vqReady = 'true';
    const list = section.querySelector('[data-vq-demo-list]');
    if (!list) return;
    const filter = section.querySelector('[data-vq-review-filter]');
    const sort = section.querySelector('[data-vq-review-sort]');
    const status = section.querySelector('[data-vq-demo-status]');
    const update = () => {
      const cards = [...list.querySelectorAll('[data-vq-demo-review]')];
      cards.sort((a, b) => sort.value === 'high' ? Number(b.dataset.rating) - Number(a.dataset.rating) : sort.value === 'low' ? Number(a.dataset.rating) - Number(b.dataset.rating) : Number(b.dataset.sequence) - Number(a.dataset.sequence));
      let shown = 0;
      cards.forEach(card => { card.hidden = filter.value !== 'all' && filter.value !== card.dataset.rating; if (!card.hidden) shown++; list.append(card); });
      section.querySelector('[data-vq-demo-count]').textContent = `${cards.length} layout samples · ${shown} shown`;
      section.querySelector('[data-vq-demo-empty]').hidden = shown !== 0;
    };
    filter.addEventListener('change', update); sort.addEventListener('change', update);
    section.addEventListener('click', event => {
      const remove = event.target.closest('[data-vq-delete-demo]');
      if (remove) { remove.closest('[data-vq-demo-review]').remove(); update(); status.textContent = 'Sample removed from this local preview only.'; }
      const photo = event.target.closest('[data-vq-photo-src]');
      if (photo) {
        const dialog = section.querySelector('[data-vq-photo-dialog]');
        dialog.querySelector('img').src = photo.dataset.vqPhotoSrc;
        dialog.querySelector('img').alt = photo.dataset.vqPhotoLabel || 'Local preview image';
        dialog.querySelector('p').textContent = photo.dataset.vqPhotoLabel || 'Local preview image — not published'; show(dialog);
      }
    });
    const dialog = section.querySelector('[data-vq-review-dialog]');
    const writeButton = section.querySelector('[data-vq-preview-write]');
    writeButton.addEventListener('click', () => show(dialog));
    writeButton.hidden = false;
    const form = section.querySelector('[data-vq-demo-form]');
    form.addEventListener('submit', async event => {
      event.preventDefault(); if (!form.reportValidity()) return;
      const data = new FormData(form); const rating = Number(data.get('rating'));
      const note = form.querySelector('[data-vq-demo-form-status]');
      const files = [...form.querySelector('[type=file]').files];
      if (!Number.isInteger(rating) || rating < 1 || rating > 5) return;
      if (files.length > 3 || files.some(file => !['image/jpeg', 'image/png', 'image/webp'].includes(file.type) || file.size > 5 * 1024 * 1024)) { note.textContent = 'Choose up to 3 JPEG, PNG or WebP files, no larger than 5 MB each.'; return; }
      const submit = form.querySelector('[type=submit]'); submit.disabled = true;
      try {
        const photos = await Promise.all(files.map(file => new Promise((resolve, reject) => { const reader = new FileReader(); reader.onload = () => resolve(reader.result); reader.onerror = () => reject(new Error('Could not read this photo.')); reader.readAsDataURL(file); })));
        const card = element('article', 'vq-review-card'); card.dataset.vqDemoReview = ''; card.dataset.rating = String(rating); card.dataset.sequence = String(Date.now());
        const person = element('div', 'vq-review-card__person'); const identity = element('div'); identity.append(element('strong', '', String(data.get('author')).trim().slice(0, 60)), element('p', 'vq-sample-label', 'LOCAL PREVIEW — NOT VERIFIED')); person.append(element('span', 'vq-initial', 'P'), identity);
        const content = element('div'); const stars = element('p', 'vq-stars', '★'.repeat(rating) + '☆'.repeat(5 - rating)); stars.setAttribute('aria-label', `Sample rating ${rating} out of 5`);
        content.append(stars, element('h3', '', String(data.get('title')).slice(0, 100)), element('p', '', String(data.get('body')).slice(0, 2000)));
        const gallery = element('div', 'vq-review-photos');
        photos.forEach(src => { const button = element('button'); button.type = 'button'; button.dataset.vqPhotoSrc = src; button.dataset.vqPhotoLabel = 'Your local preview photo — not submitted or published'; button.setAttribute('aria-label', 'Enlarge local preview photo'); const img = element('img'); img.src = src; img.alt = 'Local preview photo'; button.append(img); gallery.append(button); });
        if (photos.length) content.append(gallery);
        const remove = element('button', 'vq-text-link', 'Remove sample'); remove.type = 'button'; remove.dataset.vqDeleteDemo = '';
        card.append(person, content, remove); list.prepend(card); filter.value = 'all'; sort.value = 'recent'; update(); form.reset(); note.textContent = ''; close(dialog);
        status.textContent = 'Local preview added. It disappears on reload. Nothing was sent, saved to a server or published.';
      } catch (error) { note.textContent = error.message; }
      finally { submit.disabled = false; }
    });
    form.querySelector('[data-vq-demo-fields]').disabled = false;
    update();
  }
  function init() {
    moveModules();
    document.querySelectorAll('[data-vq-product-intelligence]').forEach(panel => {
      customElements.whenDefined('vessariq-native-product').then(() => initProduct(panel));
    });
    document.querySelectorAll('[data-vq-reviews]').forEach(initReviews);
  }
  document.addEventListener('click', event => {
    const closer = event.target.closest('[data-vq-close-dialog]'); if (closer) close(closer.closest('dialog'));
    document.querySelectorAll('.vq-family-menu[open]').forEach(menu => { if (!menu.contains(event.target)) menu.open = false; });
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') document.querySelectorAll('.vq-family-menu[open]').forEach(menu => { menu.open = false; menu.querySelector('summary').focus(); }); });
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();

if (typeof document !== 'undefined') document.addEventListener('click',event=>{const a=event.target.closest?.('a[href="#vq-reviews"]');if(a){const t=document.getElementById('vq-reviews');if(t){event.preventDefault();t.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}}});